import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";

const OvAccountsInfoContent = props => {
  const { filterState } = props;

  const renderFilterString = () => {
    let str = "Displaying data for All instance types";

    return str;
  };

  const renderDateRange = () => {
    const { period } = filterState;

    return `Data points: ${period.start.format(
      "Do MMM YYYY"
    )} - ${period.end.format("Do MMM YYYY")}`;
  };

  return (
    <div>
      <Typography component="p">{renderDateRange()}</Typography>
      <Typography component="p">{renderFilterString()}</Typography>
    </div>
  );
};

OvAccountsInfoContent.propTypes = {
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired
};

export { OvAccountsInfoContent };

export default OvAccountsInfoContent;



// WEBPACK FOOTER //
// ./src/OvAccountsInfoContent.js